<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <h2 class="titulo-pagina">{{'ALIADOSUSUARIOS.LBL_DETALLEUSUARIOS'|translate}}</h2>
  </div>
</div>
<div class="grid">
  <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ALIADOSUSUARIOS.LBL_USUARIO' | translate }}:</label>
  <label class="lg:col-3 col-6 md:col-8 "><strong>{{aliado.usuarioSistema}}</strong></label>
  <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ALIADOSUSUARIOS.LBL_TELEFONO' | translate }}:</label>
  <label class="lg:col-3 col-6 md:col-8"><strong>{{aliado.telefono | telefono}}</strong></label>
</div>

<div class="grid">
  <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ALIADOSUSUARIOS.LBL_CORREOELECTRONICO' | translate }}:</label>
  <label class="lg:col-3 col-6 md:col-8 "><strong>{{aliado.correoElectronico}}</strong></label>
  <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ALIADOSUSUARIOS.LBL_IMEI' | translate }}:</label>
  <label class="lg:col-3 col-6 md:col-8"><strong>{{aliado.imei}}</strong></label>
</div>

<div class="grid">
  <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ALIADOSUSUARIOS.LBL_VALIDACIONUBICACION' | translate }}:</label>
  <label class="lg:col-3 col-6 md:col-8 "><strong>{{(aliado.indicadorValidarUbicacion ? 'LBL_SI' : 'LBL_NO') | translate}}</strong></label>
  <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ALIADOSUSUARIOS.LBL_CHECKIN' | translate }}:</label>
  <label class="lg:col-3 col-6 md:col-8 "><strong>{{(aliado.indicadorCheckIn ? 'LBL_SI' : 'LBL_NO') | translate}}</strong></label>
</div>

<div class="grid" *ngIf="aliado.latitud || aliado.longitud">
  <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ALIADOSUSUARIOS.LBL_LATITUD' | translate }}:</label>
  <label class="lg:col-3 col-6 md:col-8 "><strong>{{aliado.latitud}}</strong></label>
  <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ALIADOSUSUARIOS.LBL_LONGITUD' | translate }}:</label>
  <label class="lg:col-3 col-6 md:col-8 "><strong>{{aliado.longitud | translate}}</strong></label>
</div>

<div class="grid">
  <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'LBL_HABILITADO' | translate }}:</label>
  <label class="lg:col-3 col-6 md:col-8 "><strong>{{(aliado.indicadorHabilitado ? 'LBL_SI' : 'LBL_NO') | translate}}</strong></label>
</div>

<div class="grid form-footer-buttons">
  <div class="form-group col-12">
    <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
            pButton (click)="regresar()"></button>
  </div>
</div>
